import { Component, EventEmitter, inject, Input, Output } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { AddressDto } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { ToastItem } from '../../toast/item/toast-item.model';
import { EToastItemType } from 'projects/shared/lib/enum/toast/toast-entry-type.enum';
import { AddressDetailComponent } from '../detail/address-detail.component';
import { IAddressService, IAddressServiceToken } from 'projects/shared/lib/services/data/address/address-service.interface';
import { IToastService, IToastServiceToken } from 'shared/services/ui/toast/toast-service.interface';

@Component({
  selector: 'app-address-list-dialog',
  imports: [
    FormsModule,
    AddressDetailComponent
  ],
  templateUrl: './address-list-dialog.component.html',
  styleUrls: ['./address-list-dialog.component.scss']
})
export class AddressListDialogComponent {
  @Input() public modalTitle?: string;
  @Input() public addressList?: AddressDto[];
  @Input() public submitButtonLabel: string;
  @Output() public modalSubmit: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  @Output() public modalCancel: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  private addressService: IAddressService;
  private readonly toastService: IToastService = inject(IToastServiceToken);
  public selectedAddress?: AddressDto;
  public isAddressSelected: boolean;

  public constructor() {
    this.addressService = inject(IAddressServiceToken);
    this.submitButtonLabel = $localize`:@@DialogAddressListSubmitButtonDefaultLabel:Close`;
    this.isAddressSelected = false;
  }

  public submit(event: MouseEvent) {
    this.modalSubmit.emit(event);
  }

  public cancel(event: MouseEvent) {
    this.modalCancel.emit(event);
  }

  public select(address: AddressDto) {
    this.selectedAddress = address;
    this.isAddressSelected = true;
  }

  public adressDeleteItem(address: AddressDto) {
    this.addressService.addressDelete(address).subscribe(b => {
      if (b) {
        this.toastService.toastItemAdd(new ToastItem({
          type: EToastItemType.Success,
          title: $localize`:@@AddressListDialogAddressDeleteInfoSuccessTitle:Success`,
          message: $localize`:@@AddressListDialogAddressDeleteInfoSuccessMessage:The Adress has been deleted.`,
        }));
        this.addressList = this.addressList?.filter(item => item !== address);
        if (this.addressList != undefined && this.addressList.length > 0) {
          this.selectedAddress = this.addressList[0];
        }
      }
    }, (ex) => {
      this.toastService.toastItemAdd(new ToastItem({
        type: EToastItemType.Danger,
        title: $localize`:@@AddressListDialogAddressDeleteInfoErrorTitle:Failure`,
        message: $localize`:@@AddressListDialogAddressDeleteInfoErrorMessage:The Adress couldn't be deleted, please try again.`,
        code: JSON.parse(ex.response).errorCode
      }));
    });
  }
}
